import IconHeart from 'icons/heart';
import React from 'react';
import { Link } from 'react-router-dom';
import style from './likedSectionPlug.module.scss';
import cx from 'classnames';

export default function LikedSectionPlug() {
  return (
    <div className={style.container}>
      <span className={cx(style.header, 'font24 fontBold')}>Понравившиеся</span>

      <div className={style.plug}>
        <IconHeart></IconHeart>
        <div className={style.texts}>
          <span className={'font20'}>
            Вам пока ничего не понравилось в этой категории
          </span>
          <span className={'font16'}>
            Перейдите, пожалуйста, на Главную, чтобы ознакомиться с нашим
            контентом
          </span>
        </div>
        <Link className={'font18 clickable-text'} to={'/'}>
          Перейти на Главную
        </Link>
      </div>
    </div>
  );
}
